<template>
  <div class="px-13 py-0">
    <v-row class="pa-0 mt-2 mb-10">
      <v-col sm="4" xs="12" order-sm="1" order-xs="2" :align="'center'">
        <v-progress-circular
          :rotate="-90"
          :value="partner_rating"
          color="#88BD1F"
          :width="8"
          :size="$vuetify.breakpoint.xs ? '160' : '180'"
          class="mr-6"
          ><span class="font font--h0-0">{{ partner_rating }} %</span></v-progress-circular
        >
      </v-col>
      <v-col sm="8" xs="9">
        <div
          :class="$vuetify.breakpoint.xs ? 'font font--money-label font-weight-medium mt-3' : 'font font--h0'"
          class="mb-6"
        >
          Ваш рейтинг партнёра
        </div>
        <div class="font font--h2 font-weight-regular mb-4">
          Ваш персональный рейтинг рассчитывается и обновляется автоматически. На него влияет 4 показателя, рассчитанных
          на данных о ваших клиентов: активность клиентов, качество, конверсия заявок в открытый счет и общая
          доходность. Рейтинг влияет на статус партнера: чем выше статус, тем выше вознаграждение –
          <a :href="'https://modulbank.ru/fs/files/tarrifs_modulpartner.pdf'" target="_blank">подробнее тут</a>.
        </div>
        <div class="text-caption font--color_light">Актуально на {{ today }}</div>
      </v-col>
    </v-row>

    <div v-if="active_score || active_score !== null" class="d-flex font">
      <v-avatar color="#F5F5F6" :size="$vuetify.breakpoint.xs ? '32' : '48'" class="mr-6">
        <img src="@/assets/img/user.svg" style="width: 18px; height: 18px" />
      </v-avatar>
      <div class="d-flex flex-column mt-1">
        <span class="mb-4" :class="$vuetify.breakpoint.xs ? 'font font--h4' : 'font font--h2'"
          >Активность клиентов<span class="ml-4">{{ active_score }} %</span></span
        >
        <span class="mb-6 font--p-sm font--color_light">
          Этот показатель отражает сколько у вас активных клиентов, которые пользуются счетом - совершают платежи,
          пополняют баланс.
        </span>
        <span class="mb-2 font-weight-medium font--color_primary">Рекомендация</span>
        <span class="font--p-sm">
          Приводите клиентов, которые планируют вести деятельность в Модульбанке, не продавайте как «резервный счет».
          Рекомендуйте своим клиентам наши сервисы для бизнеса.
        </span>
        <span class="mb-10 font--p-sm font-italic">
          А с бесплатной <a :href="'https://modulbank.ru/zelenyilimit/'" target="_blank">опцией Зеленый лимит</a> у
          наших клиентов нет необходимости держать несколько счетов в разных банках – бесплатных переводов на физлиц
          хватит.
        </span>
      </div>
    </div>
    <div v-if="quality_score || quality_score !== null" class="d-flex font">
      <v-avatar color="#F5F5F6" :size="$vuetify.breakpoint.xs ? '32' : '48'" class="mr-6">
        <img src="@/assets/img/cup.svg" style="width: 18px; height: 18px" />
      </v-avatar>
      <div class="d-flex flex-column mt-1">
        <span class="mb-4" :class="$vuetify.breakpoint.xs ? 'font font--h4' : 'font font--h2'"
          >Качество клиентов<span class="ml-4">{{ quality_score }} %</span></span
        >
        <span class="mb-6 font--p-sm font--color_light">
          Этот показатель отражает вовлеченность ваших клиентов в сомнительные и операции при ведении бизнеса (в
          соответствии с требованиями 115-ФЗ).
        </span>
        <span class="mb-2 font-weight-medium font--color_primary">Рекомендация</span>
        <span class="font--p-sm">
          Приводите реальный бизнес, а не компании, созданные для проведения сомнительных операций.
        </span>
        <span class="mb-10 font--p-sm font-italic">
          Если у вас клиент с реальным бизнесом постоянно испытывает проблемы с блокировками – поможем реабилитировать и
          защитить от блокировок
          <a :href="'https://modulbank.ru/modulblack'" target="_blank">c опцией Modulblack</a>
        </span>
      </div>
    </div>

    <div v-if="conversion_score || conversion_score !== null" class="d-flex font">
      <v-avatar color="#F5F5F6" :size="$vuetify.breakpoint.xs ? '32' : '48'" class="mr-6">
        <img src="@/assets/img/change.svg" style="width: 18px; height: 18px" />
      </v-avatar>
      <div class="d-flex flex-column mt-1">
        <span class="mb-4" :class="$vuetify.breakpoint.xs ? 'font font--h4' : 'font font--h2'"
          >Конверсия заявок<span class="ml-4">{{ conversion_score }} %</span></span
        >
        <span class="mb-6 font--p-sm font--color_light">
          Этот показатель считает соотношение заведенных вами заявок и открытых счетов.
        </span>
        <span class="mb-2 font-weight-medium font--color_primary">Рекомендация</span>
        <span class="font--p-sm">
          Не заводите заявки клиентам, которым еще не предлагали Модульбанк, чтобы «забронировать» лид. Уточняйте у
          клиента его потребности, направление бизнеса и предлагайте сервисы, которые подойдут ему.
        </span>
        <span class="mb-10 font--p-sm font-italic">
          Заинтересовать клиента помогут наши
          <a :href="'https://modulbank.ru'" target="_blank"> многочисленные сервисы</a> для любого сегмента бизнеса.
        </span>
      </div>
    </div>

    <div v-if="profit_score || profit_score !== null" class="d-flex font">
      <v-avatar color="#F5F5F6" :size="$vuetify.breakpoint.xs ? '32' : '48'" class="mr-6">
        <img src="@/assets/img/coins.svg" style="width: 18px; height: 18px" />
      </v-avatar>
      <div class="d-flex flex-column mt-1">
        <span class="mb-4" :class="$vuetify.breakpoint.xs ? 'font font--h4' : 'font font--h2'"
          >Доходность<span class="ml-4">{{ profit_score }} %</span></span
        >
        <span class="mb-6 font--p-sm font--color_light">
          Этот показатель отражает как ваши клиенты оплачивают услуги банка, платят комиссии или платят абонентскую
          плату.
        </span>
        <span class="mb-2 font-weight-medium font--color_primary">Рекомендация</span>
        <span class="mb-10 font--p-sm">
          Приводите клиентов, которые будут пользоваться продуктами банка, которые им нужны и будут оплачивать услуги
          банка. Делайте сегментные предложения, у нас есть уникальные решения под любой бизнес, например:
          <div><a :href="'https://modulbank.ru/marketplace/'" target="_blank"> Бизнес на маркетплейсах</a></div>
          <div><a :href="'https://modulbank.ru/constructing/'" target="_blank"> Строительный бизнес</a></div>
          <div><a :href="'https://modulbank.ru/b2b/'" target="_blank"> B2B–компания</a></div>
          <div><a :href="'https://modulbank.ru/onlinestore/'" target="_blank"> Интернет-магазин</a></div>
          <div><a :href="'https://modulbank.ru/commerce/'" target="_blank"> Торговля оптом</a></div>
          <div><a :href="'https://modulbank.ru/retail/'" target="_blank"> Торговля в розницу</a></div>
          <div><a :href="'https://modulbank.ru/logistics/'" target="_blank"> Транспортная компания</a></div>
          <div><a :href="'https://modulbank.ru/freelance/'" target="_blank"> Фрилансерам</a></div>
          <div><a :href="'https://modulleasing.ru/'" target="_blank"> Такси</a></div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  props: {
    partner_rating: {
      type: Number,
    },
    quality_score: {
      type: Number,
    },
    conversion_score: {
      type: Number,
    },
    profit_score: {
      type: Number,
    },
    active_score: {
      type: Number,
    },
  },

  computed: {
    showRegStepper() {
      return this.isRegStepper;
    },
    today() {
      return format(new Date(), "dd.MM.yyyy HH:mm");
    },
  },
};
</script>
